import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface GlobusMessage {
    open: boolean,
    message: string,
    variant: 'info' | 'error' | 'success' | 'warning' | 'default' | 'critical' | 'system'  // You can expand or customize this as needed
}

const initialState: GlobusMessage = { open: false, message: '', variant: 'info' }

const globusMessageSlice = createSlice({
    name: 'globus',
    initialState,
    reducers: {
        setGlobusMessage: (state, action: PayloadAction<GlobusMessage>) => {
            state.open = action.payload.open;
            state.message = action.payload.message;
            state.variant = action.payload.variant;
        },
        closeGlobusMessage: (state) => {
            state.open = false;
            state.message = '';
            state.variant = 'info';  // Reset to default
        }
    }
})

export const { setGlobusMessage, closeGlobusMessage } = globusMessageSlice.actions;
export default globusMessageSlice.reducer;